export const engagementSegmentInsightsActualStatisticsCacheKeys =
  "/engagement/segment_insights_actual_statistics" as const;
